import StrategyInvestsTable from './StrategyInvestsTable';

export default StrategyInvestsTable;
